module.exports = __webpack_public_path__ + "static/media/LinkedIn.91bb4b7e.svg";